var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile d-flex-column"},[_c('div',{staticClass:"flex-10 container p-1"},[_vm._t("notifications"),_c('router-view')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }